import React, { Component } from "react"
import PropertyNew from './components/property-new'
import { propertiesService } from '../../services/tibesa.api'
import Swal from 'sweetalert2'

export default class PropertyAdd extends Component {

    submitChanges(formData) {
        Swal.fire({
            title: '¿Seguro que deseas guardad la propiedad?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return propertiesService.create(formData)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error en la petición: ${error}`
                        )
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
            .then((response) => {
                console.log(response);
                if (response.value && response.value.data && response.value.data.status == 200) {
                    Swal.fire(
                        '¡Perfecto!',
                        '¡Nueva propiedad creada!',
                        'success'
                    ).then(() => {
                        if (response.value.data.results) {
                            window.location.href = `/properties/${response.value.data.results}`;
                        }
                        else {
                            window.location.href = '/properties';
                        }
                    });
                } else if(!response.dismiss == 'cancel') {
                    Swal.fire(
                        'Algo salio mal :C',
                        'Hubo un error al realizar la petición',
                        'error'
                      );
                }
            });
    }


    render() {
        return (
            <>
                <div className="air__utils__heading">
                    <a href="/properties">Listado de propiedades</a><span>{" "}/{" "}Agregar propiedad</span>
                </div>
                <PropertyNew onSubmit={this.submitChanges}></PropertyNew>
            </>
        )
    }
}
